module.exports = __webpack_public_path__ + "static/media/03 Oboe Region 20 Scales.369d0adb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/03 Oboe Region 20 Scales.pdf
// module id = 263
// module chunks = 0